import React, { useRef } from 'react';

import { Notification, NotificationContainer } from '@flixbus/honeycomb-react';

import styles from './styles.module.css';

const NotificationCustomizable = ({
	isShown,
	header = 'Oops! Something Went Wrong',
	label = 'An error occurred. Please reload the page to try again.',
	appearance = 'danger',
	onRemove = () => {},
}) => {
	const notificationContainer = useRef();

	const removeNotification = (ref) => {
		if (notificationContainer.current && ref && notificationContainer.current.contains(ref)) {
			ref.remove();
		}
		onRemove();
	};

	const handleCloseClick = (event, ref) => ref && removeNotification(ref);

	const closeProps = { 'aria-label': 'Close', onClick: handleCloseClick };

	return isShown ? (
		<div ref={notificationContainer}>
			<NotificationContainer extraClasses={styles.center} position="bottom-right">
				<Notification
					appearance={appearance}
					toast
					dismissCallback={removeNotification}
					closeProps={closeProps}
				>
					<div>{header}</div>
					<div className={styles.description}>{label}</div>
				</Notification>
			</NotificationContainer>
		</div>
	) : (
		<></>
	);
};

export default NotificationCustomizable;
